import { render, staticRenderFns } from "./NavigationSubMenu.vue?vue&type=template&id=5f27dffc&"
import script from "./NavigationSubMenu.vue?vue&type=script&lang=js&"
export * from "./NavigationSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports